import Api from '../apis/api';
import store from '../store/index';

// export const getUploadUrl = async (fileName, fileType) => {
//   // let rootName = store.state.userInfo.account;
//   return fetch(
//     Api.templateImageUpload + '&filename=' + fileName + '&filetype=' + fileType + '&rootName=wws',
//     {
//       mode: 'cors', // 解决跨域
//       method: 'get',
//       redirect: 'follow',
//     },
//   )
//     .then(response => response.json())
//     .then(data => {
//       return data.presignedUrl;
//     });
// };

export const getUploadUrl = async (fileName, fileType) => {
  // const rootName = store.state.userInfo.data.account;
  const response = await fetch(
    `${Api.templateImageUpload}&filename=${fileName}&filetype=${fileType}&rootName=wws`,
    { method: 'GET' },
  );
  const data = await response.json();
  // 确保返回的presignedUrl格式为：https://minio.xyabcd.com/emercontrol/...
  return data.presignedUrl;
};

// 通过url上传
/**
 *
 * @export 上传文件（url方法）通过获取带预签名的链接上传
 * @param {*} url String 预签名链接
 * @param {*} data Object 文件对象
 * @return {*} Promise
 */
export const uploadByUrl = async (url, file) => {
  return fetch(url, {
    mode: 'cors', // 解决跨域
    headers: {
      Accept: 'application/json,text/plain,/',
    },
    method: 'PUT',
    body: file,
  });
};

/**
 * @export 从存储桶中删除一个对象
 * @param {*} bucketName 存储桶的名字
 * @param {*} objectPathAndName 要删除对象的路径（注意：要写对路径，紧跟存储桶后面的路径）
 * @description
 * @author
 * @version V1.0.0
 * @return {*} Promise
 */
export function removeObject(objectPathAndName) {
  return fetch(Api.removeImageUpload + '&url=' + objectPathAndName, {
    mode: 'cors', // 解决跨域
    method: 'get',
    redirect: 'follow',
  })
    .then(response => response.json())
    .then(data => {
      return data;
    });
}
